module.exports = __webpack_public_path__ + "static/media/quote-icon.422125ab.svg";